<!--
	LearnMore.svelte

    11/22 - these are now receiving formatted service index data (not full records)
-->

<script>

    import { onMount } from 'svelte';
    import { formatPhoneNumber } from '../../common/utils.js';
    import { getIsPreferredPartner } from "../../common/utils.js";

    // TCARE components
    import SaveResourceButton from '../buttons/SaveResourceButton.svelte';

    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiPhoneInTalkOutline, mdiEmailOutline, mdiWeb, mdiArrowRightBold } from '@mdi/js';
    import Button, { Label } from '@smui/button';

    const FAKE_DESCR = "This service is a very good resource for all caregivers, They give immense support and encouragement for family caregivers whenever they attend. As a care specialist I have talked to a lot of caregivers and seen how services can change their life. This is always one of my go-to service for any care plan. They have so many virtual programs and resources it doesn’t matter if the caregiver is in the area, they get 24/7 support. As a care specialist I have talked to a lot of caregivers and seen how services can change their life. This is always one of my go-to service for any care plan. They have so many virtual programs and resources.";

    export let serviceData;
    export let onSaveResource;         // if needed

    onMount(() => {
        // console.log('');
        // console.log('LearnMore onMount');
        // console.log('serviceData:');
        // console.log(serviceData);

        // serviceData.description = FAKE_DESCR;       // TODO: REMOVE THIS LINE !!!!!
        // serviceData.description += FAKE_DESCR;
    })

    // const _onStartReferralClick = () => {
    //     // alert('_onStartReferralClick');
    //     push('/referrals');
    // }

    const _onEmailClick = () => {
        let value = serviceData.mainEmail;
        if (!value || value.length < 3) return;
        let href = 'mailto:' + value;
        window.open(href, "_blank") || window.location.replace(href);
    }
        
    const _onWebClick = () => {
        let value = serviceData.mainWebsite;
        if (!value || value.length < 3) return;
        let href = value;
        let prefix = href.substring(0, 3);
        if (prefix === 'www') {
            href = '//' + href;         // avoid localhost:
        } else {
            href = '//www.' + href;     // avoid localhost:
        }
        window.open(href, "_blank") || window.location.replace(href);
    }
        

</script>

<style>
    .learn-more {
        width: 90%;
        padding: 2%;
        padding-bottom: 4%;
        margin: auto;
        align-items: flex-start;
        font-size: 1em;
        overflow: hidden;
        user-select: none;
        background: #FFF4F7;
        border: 1px solid #FE6A8B;
        border-radius: 25px;    
    }

    .learn-more .flex-block {
        padding: 0% 2%;
    }

    .learn-more .left {
        min-height: 150px;
        padding: 0% 4% 0% 2%;
    }

    .learn-more .right {
        padding: 0% 2% 0% 2%;
        border-left: 1px solid #FE6A8B;        
    }
    
    .learn-more .text-1 {
        font-size: 20px;
        color: var(--tcare-secondary);
    }
    
    .learn-more .text-2 {
        font-size: 12px;
        color: var(--tcare-dark-purple);
    }

    .learn-more .button-row {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin-top: 15px;
    }
    
    .learn-more .text-3 {
        width: 90%;
        font-size: 12px;
        color: var(--tcare-secondary);
    }


    .learn-more .icon-row {
        margin : 5px 0px;
        align-items: center;
        justify-content: flex-start;
        font-weight: bold;
    }

    :global(.learn-more .icon-row svg) {
        width: 24px;
        height: 24px;
        outline: none;
        fill: var(--tcare-secondary);
    }

    .learn-more .w-5 {
        width: 24px;
        height: 24px;
        margin-right: 10px;
    }

    .learn-more .icon-row .link {
        text-decoration: underline;
    }

    :global(.learn-more .mdc-button)  {
        width: 160px !important;
        padding: 0px !important;
        text-transform: none;
        letter-spacing: 1px;
        border-radius: 18px;
        overflow: hidden;
        right: 0px;
    }

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 800px) {
    }

    @media screen and (min-width: 801px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

<div class="learn-more flex-row">
    <div class="flex-block left w-60">
        <div class="text-1">Description</div>
        <div class="spacer-h-15"></div>

        <div class="text-2">
            {serviceData.description}
        </div>
    </div>

    <div class="flex-block right w-40">
        <div class="text-1">I'm Interested</div>
        <div class="spacer-h-15"></div>


        <div class="text-3">
            If you would like to keep track of this service’s information, you can save this service to come back to 
            later in “My Resources.”
        </div>

        <div class="button-row">
            <SaveResourceButton onClick={onSaveResource} />
        </div>


        <!--
        <div class="text-2">
            {#if getIsPreferredPartner(serviceData)}
                Want to keep track of this preferred service for you or someone else?
            {:else}
                Want to keep track of this service for you or someone else?
            {/if}
        </div>
        <div class="spacer-h-15"></div>
        <div class="text-2">
            Fill out a quick form to recieve a copy of this service and to record the resource in “My Referrals”. 
            <br/>
            {#if getIsPreferredPartner(serviceData)}            
                This information will be sent to the service.
            {:else}
                This information will <span>not</span> be sent to the service.
            {/if}
        </div>
        -->   

        <!--
        <div class="spacer-h-15"></div>
        <Button on:click={onStartReferral} 
            variant="raised" 
            style={'background-color: var(--tcui-aqua) !important; color: var(--tcui-primary) !important;'}
        >
            <Label>Save Resource</Label>
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiArrowRightBold} /></Icon>
        </Button>  
        -->  


    </div>
</div>
